import { prefix as competitiveAnalysisPrefix } from 'components/BusinessToolForm/Sections/MarketAnalysis/CompetitiveAnalysis/utils/form';
import { prefix as consumerNeedsPrefix } from 'components/BusinessToolForm/Sections/MarketAnalysis/ConsumerNeeds/utils/form';
import { prefix as marketAnalysisOverviewPrefix } from 'components/BusinessToolForm/Sections/MarketAnalysis/MarketAnalysisOverview/utils/form';

const marketAnalysisPrefixes = [marketAnalysisOverviewPrefix, competitiveAnalysisPrefix, consumerNeedsPrefix];

export const checkIsMarketOverviewOrCompetitiveAnalysisField = (aiFieldName?: string | string[]) => {
  if (!aiFieldName) {
    return false;
  }

  if (!Array.isArray(aiFieldName)) {
    if (aiFieldName.includes(consumerNeedsPrefix)) {
      return false;
    }
  }

  const fieldNames = Array.isArray(aiFieldName) ? aiFieldName : [aiFieldName];

  return fieldNames.every((fieldName) =>
    marketAnalysisPrefixes.some((prefix) => fieldName === prefix || fieldName.startsWith(`${prefix}.`)),
  );
};
